import convertBytesToHumanReadable from "human-readable-bytes"

const humanFileSize = (bytes, precision = 0) => convertBytesToHumanReadable(bytes, 1024, precision, true)

export default humanFileSize
